import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    title = 'Espire';
}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/app.component.ts